import React from "react";
import { Link } from "../../../../link/index.js";
import { downloadFile } from "./utils/download-file.js";
import { isNativeFile } from "./utils/file-type-checker.js";
const ItemName = ({ file, href, onClick }) => {
    if (onClick && href) {
        return (React.createElement(Link, { href: href, onClick: onClick }, file.name));
    }
    if (onClick) {
        return (React.createElement(Link, { href: "#", onClick: (event) => {
                event.preventDefault();
                onClick(event);
            } }, file.name));
    }
    if (href) {
        return React.createElement(Link, { href: href }, file.name);
    }
    if (isNativeFile(file)) {
        return (React.createElement(Link, { href: "#", download: file.name, onClick: (event) => {
                event.preventDefault();
                downloadFile(file);
            } }, file.name));
    }
    return React.createElement("span", null, file.name);
};
export default ItemName;
//# sourceMappingURL=ItemName.js.map